import {type LocaleString, type LangCode} from "@atg-shared/market-config";

export function getLangCode(locale: LocaleString): LangCode {
    return locale.split("-")[0] as LangCode;
}
